import { aboutUsActions } from './aboutUsSlice'
import { fetchCachedHelper } from '../../api/api'

export const getOurReachStats = () => async dispatch => {
    dispatch(aboutUsActions.getOurReachStats())
    try {
        const response = await fetchCachedHelper(`Course/GetReach`)
        let ourReachStats = response.data

        dispatch(aboutUsActions.getOurReachStatsSuccess(ourReachStats))
    } catch (e) {
        dispatch(aboutUsActions.getOurReachStatsError(e.message))
    }
}
